import classNames from 'classnames';
import React, { ComponentProps } from 'react';
import TableRowCell from 'Components/Table/Cells/TableRowCell';
import styles from 'Components/Table/Cells/TableRowCell.css';

type TdarrTableRowCellProps = ComponentProps<typeof TableRowCell>;

export default function TdarrTableRowCell({ className, ...props }: TdarrTableRowCellProps) {
  return <TableRowCell className={classNames(styles.cell, className)} {...props} />;
}
